import { Route } from 'react-router-dom';

import { SettingsIntegrationsApiTokensCreateView } from './views/create';
import { SettingsIntegrationsApiTokensTokenView } from './views/token';

import { SettingsIntegrationsApiTokensView } from './';

export const settingsIntegrationsApiTokensRoutes = (
  <Route path="api-tokens">
    <Route path="" element={<SettingsIntegrationsApiTokensView />} />
    <Route
      path="create"
      element={<SettingsIntegrationsApiTokensCreateView />}
    />
    <Route path=":id" element={<SettingsIntegrationsApiTokensTokenView />} />
  </Route>
);
